import React from 'react'

const News: React.FunctionComponent = () => {
  return <h1>News</h1>
}

export default News
